import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NitroPanel } from 'nitro-components';
import styled from 'styled-components';

import FilterComponent from './FilterComponent';
import FilterConnectorIndicator from './FilterConnectorIndicator';

import { formatFilter } from '../../../report-edit/filters';

const FilterActions = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);

  height: 30px;
  width: 140px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  overflow: hidden;

  display: flex;

  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

const FilterAction = styled.button`
  color: ${props => props.theme.color.white};
  font-family: ${props => props.theme.font.bold};
  background: ${props =>
    props.disabled ? props.theme.color.base3 : props.theme.color.secondary};
  border: 0;
  outline: 0;
  width: 50%;
  border-right: 1px solid rgba(255, 255, 255, 0.5);
  &:last-child {
    border-right: 0;
  }
`;

const addLabel = filter => {
  filter.label = filter.label || filter.value;
  return filter;
};

class FilterSection extends Component {
  updateFilter = (index, f) => {
    let filter = [...this.props.filter];

    const formatted = addLabel(f);
    filter[index] = Object.assign({}, f, formatted);
    this.props.updateFilterSection(this.props.groupIndex, filter);
  };

  removeFilter = filterIndex => {
    const filter = [...this.props.filter];

    if (filter.length > 1) {
      filter.splice(filterIndex, 1);
      this.props.updateFilterSection(this.props.groupIndex, filter);
    } else {
      this.props.removeFilterSection(this.props.groupIndex);
    }
  };

  render() {
    const { filter, isLast, addFilter, addFilterSection } = this.props;

    const isValid = filter[filter.length - 1].value;

    const isFirstFilterGroup = isLast && this.props.groupIndex === 0;

    return (
      <div>
        <NitroPanel noMargin>
          {filter.map((f, i) => {
            const sglFilter = Object.assign({}, f);
            const isLastFilter = i === filter.length - 1;
            return (
              <FilterComponent
                key={f.index}
                index={i}
                isLastFilter={isLastFilter}
                isFirstFilterGroup={isFirstFilterGroup}
                filter={sglFilter}
                onChange={this.updateFilter}
                removeFilter={this.removeFilter}
              />
            );
          })}
          {isLast && (
            <FilterActions disabled={!isValid}>
              <FilterAction disabled={!isValid} onClick={addFilter}>
                OR
              </FilterAction>
              <FilterAction disabled={!isValid} onClick={addFilterSection}>
                AND
              </FilterAction>
            </FilterActions>
          )}
        </NitroPanel>
        {!isLast && <FilterConnectorIndicator label="AND" layout="vertical" />}
      </div>
    );
  }
}

FilterSection.propTypes = {
  filter: PropTypes.array,
  groupIndex: PropTypes.number,
  isLast: PropTypes.bool,
  addFilter: PropTypes.func,
  addFilterSection: PropTypes.func,
  removeFilterSection: PropTypes.func,
  updateFilterSection: PropTypes.func
};

export default FilterSection;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/components/FilterSection.js